import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './EditorialTopicsGrid.css';

const slides = [
  [
    {
      topic: 'AI',
      articles: [
        {
          headline: 'OpenAI Says ChatGPT Refused to Help Chinese Influence Operations',
          image: 'https://images.unsplash.com/photo-1677442135703-1787eea5ce01?w=90&h=65&fit=crop',
          slug: '/article/ai-revolution-transforms-industries',
        },
        {
          headline: 'LSEG Unveils £3 Billion Buyback as Elliott Pushes for Change',
          image: 'https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?w=90&h=65&fit=crop',
          slug: '/article/fed-hq-renovation-cost',
        },
        {
          headline: 'Did Romania\'s \'King of TikTok\' Really Sway a Presidential Election?',
          image: 'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=400&h=250&fit=crop',
          slug: '/article/us-futures-bank-earnings',
        },
        {
          headline: 'Lessons to Avoid Societal Collapse From 5,000 Years of History',
          image: 'https://images.unsplash.com/photo-1502444330042-d1a1ddf9bb5b?w=90&h=65&fit=crop',
          slug: '/article/us-futures-bank-earnings',
        },
        {
          headline: 'Anthropic\'s Pentagon Showdown Is About More Than AI',
          image: 'https://images.unsplash.com/photo-1620712943543-bcc4688e7485?w=90&h=65&fit=crop',
          slug: '/article/ai-revolution-transforms-industries',
        },
      ],
    },
    {
      topic: 'Energy',
      articles: [
        {
          headline: 'India Holds Line on Russian Oil With Trump\'s Tariffs in Question',
          image: 'https://images.unsplash.com/photo-1518770660439-4636190af475?w=90&h=65&fit=crop',
          slug: '/article/us-futures-bank-earnings',
        },
        {
          headline: 'Drax Takes Hit on Biomass Projects in Canada, UK as Profit Falls',
          image: 'https://images.unsplash.com/photo-1473341304170-971dccb5ac1e?w=90&h=65&fit=crop',
          slug: '/article/fed-hq-renovation-cost',
        },
        {
          headline: 'US, Iran to Hold Nuclear Talks as Trump\'s Deal Deadline Looms',
          image: 'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=400&h=250&fit=crop',
          slug: '/article/us-futures-bank-earnings',
        },
        {
          headline: 'Stellantis Swings to Loss After Charges Linked to EV Reversal',
          image: 'https://images.unsplash.com/photo-1593941707882-a5bba14938c7?w=90&h=65&fit=crop',
          slug: '/article/ai-revolution-transforms-industries',
        },
        {
          headline: 'Eni Reports Big Beat in Profit on Growth in Production',
          image: 'https://images.unsplash.com/photo-1610375461246-83df859d849d?w=90&h=65&fit=crop',
          slug: '/article/fed-hq-renovation-cost',
        },
      ],
    },
    {
      topic: 'Deals',
      articles: [
        {
          headline: 'KKR Sells Stake in $3.1 Billion Post-Trade Firm OSTTRA to Banks',
          image: 'https://images.unsplash.com/photo-1542744173-8e7e53415bb0?w=90&h=65&fit=crop',
          slug: '/article/us-futures-bank-earnings',
        },
        {
          headline: 'Erste Says Interest Income to Top €11 Billion After Poland Deal',
          image: 'https://images.unsplash.com/photo-1560472354-b33ff0c44a43?w=90&h=65&fit=crop',
          slug: '/article/fed-hq-renovation-cost',
        },
        {
          headline: 'Tencent Is Said to Be in Talks for Stake in \'Block Blast!\' Gaming Studio',
          image: 'https://images.unsplash.com/photo-1511512578047-dfb367046420?w=90&h=65&fit=crop',
          slug: '/article/ai-revolution-transforms-industries',
        },
        {
          headline: 'Dubai Aerospace to Buy Macquarie AirFinance for $7 Billion',
          image: 'https://images.unsplash.com/photo-1436491865332-7a61a109cc05?w=90&h=65&fit=crop',
          slug: '/article/us-futures-bank-earnings',
        },
        {
          headline: 'Asia\'s Biggest Banks Line Up Bids for HSBC Indonesia Assets',
          image: 'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=90&h=65&fit=crop',
          slug: '/article/fed-hq-renovation-cost',
        },
      ],
    },
  ],
  [
    {
      topic: 'Trade',
      articles: [
        {
          headline: 'US, China Challenge Modi\'s \'Make in India\' Factory Incentives',
          image: 'https://images.unsplash.com/photo-1578575437130-527eed3abbec?w=90&h=65&fit=crop',
          slug: '/article/us-futures-bank-earnings',
        },
        {
          headline: 'Nvidia Gets US License for Small Amount of H200 Exports to China',
          image: 'https://images.unsplash.com/photo-1518770660439-4636190af475?w=90&h=65&fit=crop',
          slug: '/article/ai-revolution-transforms-industries',
        },
        {
          headline: 'Lithium Prices Jump After Zimbabwe Bans Concentrate Exports',
          image: 'https://images.unsplash.com/photo-1529107386315-e1a2ed48a620?w=400&h=250&fit=crop',
          slug: '/article/fed-hq-renovation-cost',
        },
        {
          headline: 'Port of Long Beach Imports Fall 13% Under Tumult of Trade War',
          image: 'https://images.unsplash.com/photo-1494412651409-8963ce7935a7?w=90&h=65&fit=crop',
          slug: '/article/us-futures-bank-earnings',
        },
        {
          headline: 'Oil Steadies as Traders Focus on Upcoming US-Iran Nuclear Talks',
          image: 'https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?w=90&h=65&fit=crop',
          slug: '/article/fed-hq-renovation-cost',
        },
      ],
    },
    {
      topic: 'Currencies',
      articles: [
        {
          headline: 'Does India\'s Economy Really Rival Japan\'s?',
          image: 'https://images.unsplash.com/photo-1524492412937-b28074a5d7da?w=90&h=65&fit=crop',
          slug: '/article/us-futures-bank-earnings',
        },
        {
          headline: 'Europe\'s Capital Markets Are Making a Great Leap Forward',
          image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=90&h=65&fit=crop',
          slug: '/opinion/us-tariffs-global-trade',
          
        },
        {
          headline: 'Yuan Extends Advance to Mark Longest Winning Streak Since 2010',
          image: 'https://images.unsplash.com/photo-1526304640581-d334cdbbf45e?w=90&h=65&fit=crop',
          slug: '/article/fed-hq-renovation-cost',
        },
        {
          headline: 'Yen Outperforms G-10 Peers After Report Sustains Rate Hike Bets',
          image: 'https://images.unsplash.com/photo-1480714378408-67cf0d13bc1b?w=90&h=65&fit=crop',
          slug: '/article/us-futures-bank-earnings',
        },
        {
          headline: 'Indonesia Raises $4.5 Billion to Defy Fiscal Health Concerns',
          image: 'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=1200&h=675&fit=crop',
          slug: '/article/ai-revolution-transforms-industries',
        },
      ],
    },
    {
      topic: 'Monetary Policy',
      articles: [
        {
          headline: 'Japan Sees Interest Payments Doubling by 2029 as BOJ Hikes Rate',
          image: 'https://images.unsplash.com/photo-1480714378408-67cf0d13bc1b?w=90&h=65&fit=crop',
          slug: '/article/fed-hq-renovation-cost',
        },
        {
          headline: 'BOJ Hawk Pushes for More Hikes in Response to Heating Up Prices',
          image: 'https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?w=90&h=65&fit=crop',
          slug: '/article/us-futures-bank-earnings',
        },
        {
          headline: 'Wall Street Says Japan Yield Curve Flattening Has Gone Too Far',
          image: 'https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?w=90&h=65&fit=crop',
          slug: '/article/ai-revolution-transforms-industries',
        },
        {
          headline: 'BOK Holds Rate Steady While Projecting No Moves for Six Months',
          image: 'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=90&h=65&fit=crop',
          slug: '/article/fed-hq-renovation-cost',
        },
        {
          headline: 'Bank of Korea Adopts Fed-Inspired Dot Plot for Rates Outlook',
          image: 'https://images.unsplash.com/photo-1541354329998-f4d9a9f9297f?w=90&h=65&fit=crop',
          slug: '/article/us-futures-bank-earnings',
        },
      ],
    },
  ],
];

const EditorialTopicsGrid = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const goTo = (index) => {
    if (index >= 0 && index < slides.length) {
      setCurrentSlide(index);
    }
  };

  const columns = slides[currentSlide];

  return (
    <section className="editorial-topics-section">
      <div className="editorial-topics-slider">
        <div className="editorial-topics-grid">
          {columns.map((col, colIndex) => (
            <div className="editorial-topic-column" key={colIndex}>
              <div className="editorial-topic-header">
                <span className="editorial-topic-title">{col.topic}</span>
                {/* <button className="editorial-follow-btn">Follow</button> */}
              </div>
              <div className="editorial-articles-list">
                {col.articles.map((article, artIndex) => (
                  <div key={artIndex} className="editorial-article-wrapper">
                    <Link
                      to={article.slug}
                      className="editorial-article-item"
                      data-tooltip={article.headline}
                    >
                      <div className="editorial-article-text">
                        {article.isOpinion && (
                          <span className="editorial-opinion-label">Opinion</span>
                        )}
                        <h4 className="editorial-article-headline">
                          {article.headline}
                        </h4>
                      </div>
                      <img
                        src={article.image}
                        alt={article.headline}
                        className="editorial-article-thumb"
                      />
                    </Link>
                    <div className="editorial-tooltip">{article.headline}</div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

        {/* Dots + Arrows Navigation */}
        <div className="editorial-nav">
          <div className="editorial-dots">
            {slides.map((_, i) => (
              <button
                key={i}
                className={`editorial-dot${i === currentSlide ? ' active' : ''}`}
                onClick={() => goTo(i)}
                aria-label={`Slide ${i + 1}`}
              />
            ))}
          </div>
          <div className="editorial-arrows">
            <button
              className="editorial-arrow"
              onClick={() => goTo(currentSlide - 1)}
              disabled={currentSlide === 0}
              aria-label="Previous"
            >
              &#8249;
            </button>
            <button
              className="editorial-arrow"
              onClick={() => goTo(currentSlide + 1)}
              disabled={currentSlide === slides.length - 1}
              aria-label="Next"
            >
              &#8250;
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default EditorialTopicsGrid;
